import React from "react";
import classNames from "classnames/bind";
import { Link } from "react-router-dom";

import styles from "./SearchDropDown.module.scss";

// utils
import { convertToSlug } from "src/utils/helpers";

const cx = classNames.bind(styles);

const EventItem = ({ data }) => {
  const getSlug = () => {
    if (Object.entries(data).length > 0) {
      let slug = convertToSlug(data.EventName);
      return `/${slug}/${data.EventId}/${data.TimeId}`;
    }

    return "#";
  };

  return (
    <Link to={getSlug()}>
      <div className={cx("event-item-root")}>
        <img src={data.Image} alt={data.EventName} />
        <div className={cx("content")}>
          <h4 className={cx("title")}>{data.EventName}</h4>
          <p className={cx("location")}>{data.Location}</p>
        </div>
      </div>
    </Link>
  );
};

export default EventItem;
